$(document).ready(function() {
    // Check if the current URL contains "https://odapro.eu/en/"
    if (window.location.href.indexOf("https://odapro.eu/en/") !== -1) {
        var swiperElement = $('.swiper.mySwiperr');

        // Apply fadeIn effect with a duration of 1000ms (1 second)
        swiperElement.fadeIn(500);

        // Loop through image numbers 2 to 9
        for (var i = 2; i <= 9; i++) {
            // Construct the class selector dynamically
            var imgClass = '.custom_product_images .product_img' + i;

            // Check if there is an img element with class .product_img{i}
            var imgElements = $(imgClass);

            // Check if the img element exists
            if (imgElements.length === 0) {
                // Remove the corresponding .cimage_X element from the DOM
                $("a.cimage_" + i).remove();
                console.log("Removed a.cimage_" + i + " from the DOM");

                // Remove the parent .swiper-slide element from the DOM
                $(".mobileimage_" + i).closest('.swiper-slide').remove();
                console.log("Removed parent .swiper-slide of .mobileimage_" + i + " from the DOM");
            } else {
                // Iterate over each matching img element
                imgElements.each(function(index) {
                    // Get the src value
                    var imgSrc = $(this).attr('src');

                    // Apply the src value to the specified elements
                    $("a.cimage_" + (i + index)).attr('href', imgSrc);
                    $("a.cimage_" + (i + index)).attr('data-src', imgSrc);
                    $("a.cimage_" + (i + index) + " img.rimage__image").attr('data-lazy-src', imgSrc);
                    $("a.cimage_" + (i + index) + " img.rimage__image").attr('src', imgSrc);
                    $(".mainimg_" + (i + index) + " a.main-img-link").attr('href', imgSrc);
                    $(".mainimg_" + (i + index) + " img.rimage__image").attr('data-lazy-src', imgSrc);
                    $(".mainimg_" + (i + index) + " img.rimage__image").attr('src', imgSrc);
                    $(".mobileimage_" + (i + index)).attr('src', imgSrc);
                });
            }
        }
    }




});

    // jQuery code to update button content
  $(document).ready(function() {
    // Target the button with the class "disclosure__toggle"
    var button = $('.disclosure__toggle');

    // Check the current content and update it accordingly
    if (button.text().trim() === 'English') {
      button.contents().first().replaceWith('EN');
    } else if (button.text().trim() === 'Lietuvių (Lietuva)') {
      button.contents().first().replaceWith('LT');
    }
  });

















/* arrows*/

document.addEventListener("DOMContentLoaded", function () {
  var thumbnails = document.querySelectorAll('.desktop-slid .thumbnail');
  var activeIndex = Array.from(thumbnails).findIndex(function (thumbnail) {
    return thumbnail.classList.contains('active');
  });

  var promotionals = document.querySelector('.main .promotionals');
  var firstClick = true; // Flag to track the first click

  // Function to update active index and adjust promotional display
  function updateActiveIndex(index) {
    activeIndex = index;
    console.log(activeIndex);
    if (activeIndex >= 1) {
      promotionals.style.display = 'none';
      console.log("hidden");
    } else {
      promotionals.style.display = '';
    }
  }

  // Click event listener for next button
  document.querySelector('.swiper-button-next.desktoparrows').addEventListener('click', function () {
    if (firstClick) {
      firstClick = false; // Reset the flag after the first click
      updateActiveIndex((activeIndex + 1) % thumbnails.length);
      thumbnails[activeIndex].click();
    }
    updateActiveIndex((activeIndex + 1) % thumbnails.length);
    thumbnails[activeIndex].click();
  });

  // Click event listener for previous button
  document.querySelector('.swiper-button-prev.desktoparrows').addEventListener('click', function () {
    if (firstClick) {
      firstClick = false; // Reset the flag after the first click
      updateActiveIndex((activeIndex - 1 + thumbnails.length) % thumbnails.length);
      thumbnails[activeIndex].click();
    }
    updateActiveIndex((activeIndex - 1 + thumbnails.length) % thumbnails.length);
    thumbnails[activeIndex].click();
  });

  // Event listener for any change in active thumbnail
  thumbnails.forEach(function(thumbnail, index) {
    thumbnail.addEventListener('click', function() {
      updateActiveIndex(index);
    });
  });
});




jQuery(document).ready(function($) {
  function truncateText(executionCount) {
    setTimeout(function() {
      $('.product-gallery .ga-products a.ga-product_title').each(function() {
        var originalText = $(this).text().trim();
        if (originalText.length > 26) {
          var truncatedText = originalText.substring(0, 26) + '...';
          $(this).text(truncatedText);
        }
      });

      $('.ga-carousel_wrapper a.ga-product_title').each(function() {
        var originalText = $(this).text().trim();
        if (originalText.length > 26) {
          var truncatedText = originalText.substring(0, 26) + '...';
          $(this).text(truncatedText);
        }
      });

      if (executionCount < 2) {
        truncateText(executionCount + 1);
      }
    }, 3500); // 2000 milliseconds = 2 seconds
  }

  truncateText(1); // Start the first execution
});





  $(document).ready(function() {
    var $atcButton = $('span.payment-and-quantity__add button.btn.product-add.mini-form');
    var $atcButton2 = $('.sticky-add-to-cart button#add-to-cart-btn');
    var $optionSelectors = $('.option-selectors');
    var $selects = $optionSelectors.find('select');

    function checkVariantSelection() {
      var allSelected = true;

      $selects.each(function() {
        if ($(this).val() === "") {
          allSelected = false;
        }
      });

      if (allSelected) {
        $atcButton.prop('disabled', false).removeClass('disabled');
        $atcButton2.prop('disabled', false).removeClass('disabled');
      } else {
        $atcButton.prop('disabled', true).addClass('disabled');
        $atcButton2.prop('disabled', true).addClass('disabled');
      }
    }

    // Check if .option-selectors exists
    if ($optionSelectors.length > 0) {
      // Initially disable the ATC button
      $atcButton.prop('disabled', true).addClass('disabled');
      $atcButton2.prop('disabled', true).addClass('disabled');

      // Check variant selection on change
      $selects.on('change', checkVariantSelection);
    }
  });